import { useRef } from "react";
import newId from "../../../lib/id-utils.js";
import cx from "../../../lib/cx.js";
import styles from "./multiselect.css";

function Multiselect({
  name,
  label,
  description,
  options,
  selected,
  required = false,
  onChange,
  theme = "dark",
  error,
}) {
  const id = useRef(newId());

  const onMouseDown = (e) => {
    if (e.target.tagName === "OPTION") {
      e.preventDefault(); // Prevent default selection behavior
      const option = e.target;

      // Toggle selection state
      option.selected = !option.selected;

      // Trigger onChange with a custom event
      if (onChange) {
        const selectedOptions = Array.from(e.target.parentNode.options).filter(
          (opt) => opt.selected,
        );

        onChange({
          target: {
            name,
            selectedOptions,
          },
        });
      }
    }
  };

  return (
    <div className={styles.selectGroup({ theme })}>
      {label && (
        <label htmlFor={id.current}>
          {label}
          {required && " *"}
        </label>
      )}
      {description && <p className={styles.description}>{description}</p>}
      <select
        name={name || id.current}
        id={id.current}
        value={selected}
        onMouseDown={onMouseDown}
        onChange={() => {}}
        className={cx(
          styles.selectContainer({ theme }),
          error ? styles.error : "",
        )}
        multiple
      >
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            className={styles.option({ theme })}
          >
            {option.label ?? option.value}
          </option>
        ))}
      </select>
      {error && <p className={styles.errorText}>{error}</p>}
    </div>
  );
}

export default Multiselect;
